module.exports = __webpack_public_path__ + "static/media/elo.42274f50.png";